import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import API from "../api";

export default function Register() {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("")
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const GOOGLE_AUTH_URL = `${process.env.REACT_APP_API_URL}/auth/google`;


    async function handleSubmit(e) {
        e.preventDefault();
        setErrorMessage("")

        if (fullName === '' || email === '' || password === '') {
            setErrorMessage('Please fill all the form')
            return
        }

        const cleanFullName = fullName.replace(/[<>{}()"'`]/g, "").trim();
        const cleanEmail = email.replace(/[<>{}()"'`]/g, "").trim();

        // Validation de mot de passe fort
        const passwordRegex =
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[{\]}|\\;:'",.<>/?]).{8,}$/;

        if (!passwordRegex.test(password)) {
            setErrorMessage(
                "Password must contain at least 8 characters, one uppercase letter, one number, and one special symbol."
            );
            return;
        }
    
        try {
            await API.post("/register", {
            fullName: cleanFullName,
            email: cleanEmail,
            password
            }, {
                withCredentials: true,
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY, // clé API envoyée
                },
            });

                  // Affiche le popup pour vérifier l'email
            setPopupMessage(
                "An email has been sent to your account. Please click on the link to verify your account"
            );
            setShowPopup(true);

            // Redirige après 3 secondes
            setTimeout(() => {
                setShowPopup(false);
                navigate("/login");
            }, 5000);
        } catch (error) {
            if (error.status === 409) {
                setErrorMessage("Email already registered");
            } else {
                setErrorMessage('An error has occurred')
            }
            console.error("❌ Erreur :", error);
        }
    }

    // Password strength calculation
    const strengthChecks = [
        password.length >= 8,
        /[A-Z]/.test(password),
        /\d/.test(password),
        /[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]/.test(password),
    ];
    
    const strength = strengthChecks.filter(Boolean).length;
    
    const barColors = [
        "bg-red-600",
        "bg-orange-500",
        "bg-yellow-500",
        "bg-green-500",
    ];
    
    const strengthColor = strength > 0 ? barColors[strength - 1] : "bg-red-600";
    

    return (
        <div className="relative min-h-screen bg-[#0D1117] flex items-center justify-center px-4 sm:px-6 lg:px-8">

        <Header />

    {/* Background graphique */}
    <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
        <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
    </div>

    {/* Formulaire */}
    <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8 mt-20">
        <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2 font-pj">
            Create your account 🚀
        </h2>
        <p className="text-center text-[#8B949E] mb-8">
            Join our community and start exploring
        </p>

        <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
                <label className="block text-[#8B949E] mb-1 font-medium">Full name</label>
                <input
                    type="text"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                    placeholder="John Doe"
                    required
                />
            </div>

            <div>
                <label className="block text-[#8B949E] mb-1 font-medium">Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                    placeholder="you@example.com"
                    required
                />
            </div>

            <div>
                <label className="block text-[#8B949E] mb-1 font-medium">Password</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3 border border-[#30363D] rounded-xl focus:ring-2 focus:ring-[#1F6FEB] focus:outline-none bg-[#0D1117] text-[#E6EDF3] placeholder-[#6E7681]"
                    placeholder="••••••••"
                    required
                />
                {/* Password Strength Bar */}
                <div className="w-full h-2 rounded-md bg-[#30363D] mt-2">
                <div
                    className={`h-full rounded-md transition-all duration-300 ${strengthColor}`}
                    style={{ width: `${(strength / 4) * 100}%` }}
                ></div>
                </div>
            </div>

            <button
                type="submit"
                className="w-full py-3 mt-4 text-white bg-[#1F6FEB] hover:bg-[#388BFD] rounded-xl font-semibold transition shadow-[0_0_10px_#1F6FEB]/30"
            >
                Register
            </button>
        </form>
        <div className="flex flex-col gap-3 mt-4">
        <a
            href={GOOGLE_AUTH_URL}
            className="w-full py-3 flex justify-center items-center text-[#202124] bg-white hover:bg-gray-200 rounded-xl font-semibold transition shadow-[0_0_10px_#FF0000]/30"
        >
            <svg
            className="w-5 h-5 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            >
            <path
                fill="#FFC107"
                d="M43.6 20.5H42V20H24v8h11.3C34.6 34 29.5 38 24 38c-7 0-12.7-5.7-12.7-12.7S17 12.6 24 12.6c3.2 0 6 1.2 8.2 3.2l5.8-5.8C34 5.6 29.1 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c11.5 0 21-9.4 21-21 0-1.4-.1-2.8-.4-4.5z"
            />
            <path
                fill="#FF3D00"
                d="M6.3 14.3l6.6 4.8C14 15.3 18.7 12.6 24 12.6c3.2 0 6 1.2 8.2 3.2l5.8-5.8C34 5.6 29.1 3 24 3 16 3 9.1 7 6.3 14.3z"
            />
            <path
                fill="#4CAF50"
                d="M24 45c5.1 0 9.9-1.9 13.5-5.1l-6.2-5c-2 1.4-4.6 2.2-7.3 2.2-5.5 0-10.2-3.9-11.8-9.1l-6.7 5.1C7.9 40.7 15.4 45 24 45z"
            />
            <path
                fill="#1976D2"
                d="M43.6 20.5H42V20H24v8h11.3c-1.1 3-3.5 5.5-6.7 6.8l6.2 5C41.7 34.5 45 29.6 45 24c0-1.4-.1-2.8-.4-4.5z"
            />
            </svg>
            Sign up with Google
        </a>
        </div>


        <p className="text-center text-[#8B949E] mt-6">
            Already have an account?{" "}
            <a href="/login" className="font-semibold text-[#1F6FEB] hover:underline">
                Login
            </a>
        </p>
        {errorMessage && (
            <p className="text-red-500 text-sm mt-2 text-center">{errorMessage}</p>
        )}

        {/* Popup de confirmation d’envoi email */}
        {showPopup && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
        <div className="bg-[#161B22] border border-[#21262D] rounded-xl px-8 py-10 w-11/12 max-w-sm text-center relative">

        {/* Close Button */}
        <button
        className="absolute top-4 right-4 text-[#9BA6B3] hover:text-[#E6EDF3] text-xl font-bold transition"
        onClick={() => setShowPopup(false)}
        >
        ×
        </button>

        {/* Icon */}
        <div className="mx-auto mb-4 w-12 h-12 flex items-center justify-center rounded-full bg-[#1F6FEB]/20">
        <svg
            className="w-6 h-6 text-[#3B82F6]"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
        >
            <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m0 8V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2z"
            />
        </svg>
        </div>

        {/* Message */}
        <h3 className="text-lg font-semibold text-white mb-2">
        {popupMessage}
        </h3>

        <p className="text-sm text-[#9BA6B3]">
        Please check your inbox to verify your account.
        </p>
        </div>
        </div>
        )}


    </div>
</div>

    );
}
